import { IContact } from 'models';
import { Dispatch } from 'redux';
import ContactService from '../../services/contact.service';
import { CrudActions, EActionGetType, ECrudType } from './crud';

export const GetContactName = (obj: IContact): string => {
  if (!obj) {
    return '';
  }
  return obj.fullName;
};

class ContactActions<T extends { id?: string }> extends CrudActions<T> {
  GetDropdown(params: any = undefined) {
    return async (dispatch: Dispatch) => {
      try {
        if (typeof params !== 'undefined') this.paramsDrop = params;
        const result: any = await this.service.GetDropdown(this.paramsDrop);
        result.data = result.data.map((r: any) => ({
          ...r,
          name: GetContactName(r),
        }));
        dispatch(this.GetSuccess(result, EActionGetType.DROPDOWN, false));
      } catch (error) {
        dispatch(this.GetFail(error as any));
      }
    };
  }
}

export default new ContactActions<IContact>(ECrudType.contacts, ContactService);
